import a from "axios";
function n(e = {}) {
  const { withCredentials: t = !0, headers: r = {}, baseURL: s } = e;
  return a.create({
    withCredentials: t,
    baseURL: s,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      ...r
    }
  });
}
export {
  n as createHttpClient
};
